module.exports = __webpack_public_path__ + "static/media/a3_01.d5037e84.jpg";